import classNames from 'classnames';

import styles from './HeaderNavToggle.module.scss';
import type { HeaderNavToggleProps } from './HeaderNavToggle.types';

export function HeaderNavToggle({ className, isActive }: HeaderNavToggleProps) {
  return (
    <button
      className={classNames(styles.navToggle, className, {
        [styles.active]: isActive,
      })}
    >
      <span className={styles.iconToggle} />
    </button>
  );
}
